export const RAISON_EXPERT_ROLE = 'ROLE_EXPERT';
export const RAISON_PARAMETERIZER_ROLE = 'ROLE_PARAMETERIZER';

export const DEPLOYMENT_STATUS_ONLINE = 'online';
export const DEPLOYMENT_STATUS_PENDING = 'pending';
export const DEPLOYMENT_STATUS_OFFLINE = 'offline';
export const DEPLOYMENT_STATUS_ASKED = 'asked';
export const DEPLOYMENT_STATUS_FAILED = 'failed';
export const DEPLOYMENT_STATUS_NOT_DEPLOYED = 'not_deployed';
